// Two letters standing in for a brand that has no logo: "Maruti Suzuki" -> "MS".
// A one-word name gives its first two letters ("Hyundai" -> "HY").
export function brandInitials(name) {
  const words = String(name || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (!words.length) return "";
  const letters = words.length > 1 ? words[0][0] + words[1][0] : words[0].slice(0, 2);
  return letters.toUpperCase();
}
